import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
`;

export const Content = styled.div`
  max-width: 600px;
  width: 100%;
  padding: 32px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

export const Title = styled.h1`
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: center;
`;

export const Description = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: center;
`;

export const Button = styled(Link)`
  text-decoration: none;
  width: 304px;
  height: 48px;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const Icon = styled.div`
  color: #2d5bff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;
